<template>
	<div>
		<div class="empty-text" v-if="data.length==0">暂无数据...</div>
		<ul class="lesson-items" v-dt-infinite-scroll="getData">
			<!--<li class="lesson-item lesson-item-unopen">
				<div class="lesson-main f-cb">
					<div class="lesson-pic f-img-box">
						<img src="./lesson-pic.png">
						<div class="lesson-status-open">正在开课</div>
						<div class="lesson-status-unopen">即将开课</div>
					</div>
					<div class="lesson-content">
						<div class="lesson-title o1">葡萄酒与西方文化葡萄酒与西方文化</div>
						<div class="lesson-place o1">天津文化馆</div>
						<div class="lesson-date o1">2018.8.1-2018.9.15</div>
					</div>
				</div>
			</li>-->
			<li class="lesson-item lesson-item-other lesson-item-open" v-for="item in data" @click="$router.push('/lesson-detail/'+item.id)">
				<div class="lesson-main f-cb">
					<div class="lesson-pic f-img-box">
						<img :src="item.cover_img">
						<div class="lesson-status-open" v-if="getLessonStatus(item)===1">正在开课</div>
						<div class="lesson-status-unopen" v-else-if="getLessonStatus(item)===2">即将开课</div>
						<div class="lesson-status-unopen" v-else-if="getLessonStatus(item)===3">已过期</div>
						<div class="lesson-status-unopen" v-else-if="getLessonStatus(item)===4">暂未开放</div>
					</div>
					<div class="lesson-content">
						<div class="lesson-title o1">{{item.course_title}}</div>
						<div class="lesson-place o1">{{item.teacher_info.nick_name}}<div class="float-right">{{conversionStudyPercent(item.schedule)}}</div></div>
						<div class="lesson-date o1">{{getTerm(item)}}</div>
					</div>
				</div>

			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:[]
			}
		},
		methods:{
			getData(page){
				return new Promise((resolve,reject)=>{
					this.$api.get("",{
						api:"/v1/user/read",
						user_type:1,
						len:5,
						page,
						id:this.$route.params.id
					},res=>{
						var data=res.data.course;
						this.data=this.data.concat(data);
						if(data.length<5){
							reject();
						}
						else{
							resolve();
						}
					})
				})
			},
        	getLessonStatus(item){
        		//返回1正在开课 2即将开课 3已过期 4暂未开放
        		var openStatus=item.open_status,
        			num,
        			now=new Date().getTime()/1000,
        			stime=item.start_time,
        			etime=item.end_time;
        		if(openStatus==2){
        			num=1;
        		}
        		else if(openStatus==0){
        			num=4;
        		}
        		else if(openStatus==1){
        			if(now<stime){
        				num=2;
        			}
        			else if(now>etime){
        				num=3;
        			}
        			else{
        				num=1
        			}
        		}
        		return num;
        	},
        	getTerm(item){
        		var statusText="";
        		if(item.open_status===0){
        			statusText="暂未开放";
        		}
        		else if(item.open_status===2){
        			statusText="无限期";
        		}
        		else{
        			statusText=this.tools.timestampConversion(item.start_time)+"-"+this.tools.timestampConversion(item.start_time);
        		}
        		return statusText;
        	},
        	conversionStudyPercent(str){
        		var percent=parseInt(str);
        		if(percent==0){
        			return "未开始";
        		}
        		else if(percent==100){
        			return "已学完";
        		}
        		else{
        			return "已学 "+str;
        		}
        	}
		}
	}
</script>

<style>
	.lesson{
		padding-bottom: 0.266rem;
	}
	.lesson-items{
		padding-top:0.706rem;
	}
	.lesson-item{
		margin:0 0.4rem 0.4rem 0.4rem;
	}
	.lesson-item-other{
		padding-bottom: 0.4rem;
		border-bottom: 1px solid #eee;
	}
	.lesson-pic{
		position: relative;
		float:left;
		width:3.733rem;
		height:2.133rem;
		border-radius: 0.106rem;
	}
	.lesson-status-open,
	.lesson-status-unopen{
		position: absolute;
		top:0;
		right:0;
		width:1.64rem;
		height:0.613rem;
		border-radius: 0.106rem;
		font-size: 0.346rem;
		color:#fff;
		line-height: 0.613rem;
		text-align: center;
	}
	.lesson-status-open{
		background:#ec6d3a;
	}
	.lesson-status-unopen{
		background:#3192e0;
	}
	.lesson-item-open .lesson-status-open{
		display: block;
	}
	.lesson-item-unopen .lesson-status-unopen{
		display: block;
	}
	.lesson-content{
		float:right;
		width:5.2rem;
		padding-top:0.133rem;
	}
	.lesson-title{
		font-size: 0.453rem;
		color:#333;
	}
	.lesson-place{
		margin-top:0.213rem;
		font-size:0.346rem;
		color:#999;
	}
	.lesson-date{
		margin-top:0.5rem;
		font-size:0.346rem;
		color:#EC6D3A;
	}
</style>



// WEBPACK FOOTER //
// src/components/other-history/other-history.vue